<template>
  <header id="control-bar">
    <div class='navbar-left'>
      <div class="sidebar-nav">
        <button @click="$emit('change-sidebar-view', 'console')" v-bind:class="{highlightedButton : sidebarViewState == 'console'}">
          <svg id="console-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="37.5pt" height="37.499999pt" viewBox="0 0 37.5 37.499999" version="1.2">
            <g id="surface1">
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 10.867188 36.09375 C 10.320312 36.09375 9.769531 35.882812 9.351562 35.460938 C 8.515625 34.613281 8.515625 33.242188 9.351562 32.394531 L 22.628906 18.984375 L 9.351562 5.574219 C 8.515625 4.730469 8.515625 3.355469 9.351562 2.511719 C 10.191406 1.664062 11.546875 1.664062 12.386719 2.511719 L 28.695312 18.984375 L 12.386719 35.460938 C 11.964844 35.882812 11.417969 36.09375 10.867188 36.09375 "/>
            </g>
          </svg>
          Console
        </button>
        <!-- <button @click="$emit('change-sidebar-view', 'code')" v-bind:class="{highlightedButton : sidebarViewState == 'code'}">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="37.5pt" height="37.499999pt" viewBox="0 0 37.5 37.499999" version="1.2">
            <g id="surface1">
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 9.644531 27.472656 C 9.367188 27.472656 9.089844 27.367188 8.878906 27.152344 L 0.664062 18.824219 L 8.878906 10.496094 C 9.300781 10.066406 9.984375 10.066406 10.40625 10.496094 C 10.828125 10.921875 10.828125 11.617188 10.40625 12.042969 L 3.71875 18.824219 L 10.40625 25.601562 C 10.828125 26.03125 10.828125 26.722656 10.40625 27.152344 C 10.195312 27.367188 9.921875 27.472656 9.644531 27.472656 "/>
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 27.363281 27.472656 C 27.085938 27.472656 26.808594 27.367188 26.597656 27.152344 C 26.175781 26.722656 26.175781 26.03125 26.597656 25.601562 L 33.285156 18.824219 L 26.597656 12.042969 C 26.175781 11.617188 26.175781 10.921875 26.597656 10.496094 C 27.019531 10.066406 27.703125 10.066406 28.128906 10.496094 L 36.34375 18.824219 L 28.128906 27.152344 C 27.914062 27.367188 27.640625 27.472656 27.363281 27.472656 "/>
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 13.65625 33.753906 C 13.523438 33.753906 13.386719 33.726562 13.253906 33.671875 C 12.699219 33.449219 12.433594 32.808594 12.652344 32.25 L 23.625 4.582031 C 23.847656 4.019531 24.476562 3.75 25.03125 3.972656 C 25.582031 4.199219 25.851562 4.835938 25.628906 5.398438 L 14.660156 33.066406 C 14.488281 33.492188 14.085938 33.753906 13.65625 33.753906 "/>
            </g>
          </svg>
          Code
        </button> -->
        <button @click="$emit('change-sidebar-view', 'drone')" v-bind:class="{highlightedButton : sidebarViewState == 'drone'}">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="37.5pt" height="37.499999pt" viewBox="0 0 37.5 37.499999" version="1.2">
            <g id="surface1">
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 25.609375 22.625 C 25.515625 22.453125 25.488281 22.269531 25.523438 22.078125 C 25.523438 21.769531 25.550781 21.527344 25.550781 21.207031 L 25.550781 16.945312 C 25.550781 16.628906 25.523438 16.382812 25.523438 16.078125 C 25.492188 15.886719 25.519531 15.707031 25.609375 15.53125 L 29.78125 10.292969 C 30.160156 9.90625 30.367188 9.445312 30.410156 8.90625 C 30.414062 8.558594 30.289062 8.261719 30.035156 8.023438 C 29.800781 7.816406 29.523438 7.714844 29.210938 7.714844 C 28.683594 7.691406 28.25 7.882812 27.90625 8.285156 L 22.535156 12.445312 C 22.378906 12.589844 22.195312 12.640625 21.984375 12.601562 C 21.699219 12.535156 21.410156 12.503906 21.117188 12.503906 L 16.863281 12.503906 C 16.59375 12.507812 16.328125 12.539062 16.0625 12.601562 C 15.839844 12.644531 15.640625 12.59375 15.464844 12.445312 L 10.210938 8.355469 C 9.847656 7.9375 9.390625 7.726562 8.835938 7.722656 C 8.503906 7.71875 8.207031 7.820312 7.945312 8.03125 C 7.738281 8.292969 7.636719 8.589844 7.640625 8.925781 C 7.675781 9.425781 7.863281 9.859375 8.207031 10.226562 L 12.367188 15.53125 C 12.507812 15.691406 12.558594 15.875 12.523438 16.082031 C 12.460938 16.367188 12.429688 16.65625 12.425781 16.949219 L 12.425781 21.207031 C 12.429688 21.5 12.460938 21.789062 12.523438 22.074219 C 12.5625 22.285156 12.511719 22.46875 12.367188 22.628906 L 8.269531 27.917969 C 7.882812 28.273438 7.671875 28.710938 7.640625 29.234375 C 7.636719 29.566406 7.742188 29.859375 7.949219 30.117188 C 8.191406 30.371094 8.492188 30.484375 8.839844 30.460938 C 9.367188 30.453125 9.800781 30.253906 10.148438 29.859375 L 15.46875 25.699219 C 15.644531 25.546875 15.847656 25.496094 16.074219 25.542969 C 16.332031 25.605469 16.597656 25.640625 16.867188 25.640625 L 21.125 25.640625 C 21.417969 25.644531 21.707031 25.609375 21.992188 25.542969 C 22.039062 25.535156 22.089844 25.53125 22.140625 25.53125 C 22.296875 25.53125 22.429688 25.585938 22.546875 25.695312 L 27.84375 29.816406 C 28.199219 30.246094 28.660156 30.460938 29.21875 30.460938 C 29.550781 30.480469 29.824219 30.371094 30.042969 30.121094 C 30.300781 29.882812 30.425781 29.585938 30.417969 29.234375 C 30.386719 28.734375 30.195312 28.304688 29.847656 27.941406 Z M 26.492188 10.332031 C 26.625 10.199219 26.785156 10.136719 26.96875 10.136719 C 27.15625 10.136719 27.3125 10.199219 27.445312 10.332031 L 27.753906 10.613281 C 27.898438 10.746094 27.96875 10.90625 27.96875 11.101562 C 27.96875 11.296875 27.898438 11.457031 27.753906 11.589844 C 27.617188 11.707031 27.460938 11.777344 27.28125 11.792969 C 27.082031 11.796875 26.914062 11.730469 26.777344 11.589844 L 26.492188 11.320312 C 26.339844 11.191406 26.265625 11.023438 26.269531 10.824219 C 26.269531 10.625 26.347656 10.460938 26.5 10.332031 Z M 11.546875 11.324219 L 11.238281 11.589844 C 11.105469 11.722656 10.949219 11.792969 10.757812 11.796875 C 10.570312 11.792969 10.414062 11.722656 10.285156 11.582031 C 10.214844 11.523438 10.15625 11.453125 10.117188 11.367188 C 10.078125 11.28125 10.058594 11.191406 10.058594 11.097656 C 10.058594 11.003906 10.078125 10.914062 10.117188 10.832031 C 10.15625 10.746094 10.214844 10.671875 10.285156 10.613281 L 10.53125 10.328125 C 10.675781 10.199219 10.847656 10.132812 11.039062 10.132812 C 11.234375 10.132812 11.40625 10.199219 11.550781 10.328125 C 11.667969 10.472656 11.726562 10.640625 11.726562 10.824219 C 11.726562 11.011719 11.667969 11.179688 11.550781 11.324219 Z M 11.546875 27.847656 C 11.390625 27.953125 11.222656 28.003906 11.035156 28.003906 C 10.851562 28.003906 10.679688 27.953125 10.527344 27.847656 L 10.28125 27.539062 C 10.148438 27.410156 10.082031 27.25 10.082031 27.0625 C 10.082031 26.878906 10.148438 26.71875 10.28125 26.585938 C 10.410156 26.453125 10.570312 26.390625 10.757812 26.390625 C 10.945312 26.390625 11.101562 26.457031 11.234375 26.589844 L 11.542969 26.832031 C 11.65625 26.980469 11.714844 27.152344 11.71875 27.339844 C 11.71875 27.527344 11.664062 27.699219 11.550781 27.847656 Z M 27.757812 27.539062 L 27.449219 27.847656 C 27.308594 27.964844 27.152344 28.015625 26.972656 28.003906 C 26.796875 28 26.640625 27.949219 26.496094 27.847656 C 26.347656 27.710938 26.273438 27.542969 26.273438 27.339844 C 26.273438 27.136719 26.347656 26.964844 26.496094 26.828125 L 26.785156 26.582031 C 26.917969 26.449219 27.078125 26.378906 27.265625 26.378906 C 27.453125 26.375 27.613281 26.441406 27.75 26.570312 C 27.882812 26.703125 27.953125 26.863281 27.953125 27.050781 C 27.957031 27.238281 27.890625 27.402344 27.761719 27.535156 Z M 27.757812 27.539062 "/>
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 8.21875 14.105469 L 8.21875 12.753906 C 7.925781 12.753906 7.636719 12.722656 7.351562 12.667969 C 7.0625 12.609375 6.785156 12.527344 6.515625 12.414062 C 6.242188 12.304688 5.988281 12.167969 5.742188 12.003906 C 5.5 11.84375 5.277344 11.660156 5.070312 11.453125 C 4.863281 11.246094 4.675781 11.019531 4.515625 10.777344 C 4.351562 10.535156 4.214844 10.28125 4.101562 10.007812 C 3.988281 9.738281 3.90625 9.460938 3.847656 9.175781 C 3.789062 8.886719 3.761719 8.597656 3.761719 8.304688 C 3.761719 8.015625 3.789062 7.726562 3.847656 7.4375 C 3.902344 7.152344 3.988281 6.871094 4.097656 6.601562 C 4.210938 6.332031 4.347656 6.074219 4.507812 5.832031 C 4.671875 5.589844 4.855469 5.363281 5.0625 5.15625 C 5.269531 4.949219 5.492188 4.765625 5.734375 4.601562 C 5.976562 4.441406 6.234375 4.304688 6.503906 4.191406 C 6.773438 4.078125 7.054688 3.996094 7.339844 3.9375 C 7.625 3.878906 7.914062 3.851562 8.207031 3.851562 C 8.5 3.851562 8.789062 3.878906 9.078125 3.933594 C 9.363281 3.992188 9.640625 4.078125 9.910156 4.1875 C 10.183594 4.300781 10.4375 4.4375 10.679688 4.597656 C 10.925781 4.761719 11.148438 4.945312 11.355469 5.152344 C 11.5625 5.359375 11.75 5.582031 11.910156 5.824219 C 12.074219 6.070312 12.210938 6.324219 12.324219 6.59375 C 12.433594 6.863281 12.519531 7.144531 12.578125 7.429688 C 12.632812 7.714844 12.664062 8.007812 12.664062 8.296875 L 14.066406 8.296875 C 14.066406 7.914062 14.035156 7.53125 13.960938 7.152344 C 13.890625 6.773438 13.78125 6.40625 13.636719 6.050781 C 13.492188 5.691406 13.3125 5.351562 13.101562 5.03125 C 12.890625 4.710938 12.648438 4.410156 12.378906 4.136719 C 12.109375 3.863281 11.8125 3.617188 11.496094 3.402344 C 11.175781 3.183594 10.839844 3.003906 10.484375 2.851562 C 10.128906 2.703125 9.761719 2.589844 9.386719 2.511719 C 9.007812 2.433594 8.628906 2.394531 8.242188 2.394531 C 7.855469 2.390625 7.476562 2.425781 7.097656 2.5 C 6.71875 2.574219 6.351562 2.683594 5.996094 2.828125 C 5.636719 2.972656 5.300781 3.152344 4.976562 3.363281 C 4.65625 3.578125 4.359375 3.820312 4.085938 4.089844 C 3.8125 4.363281 3.566406 4.65625 3.351562 4.976562 C 3.136719 5.296875 2.957031 5.632812 2.808594 5.988281 C 2.65625 6.34375 2.546875 6.710938 2.46875 7.089844 C 2.394531 7.464844 2.355469 7.847656 2.351562 8.230469 C 2.351562 8.617188 2.386719 9 2.460938 9.378906 C 2.535156 9.753906 2.648438 10.121094 2.792969 10.480469 C 2.941406 10.835938 3.121094 11.171875 3.335938 11.492188 C 3.546875 11.816406 3.789062 12.109375 4.0625 12.382812 C 4.335938 12.65625 4.628906 12.902344 4.949219 13.113281 C 5.269531 13.328125 5.609375 13.511719 5.964844 13.65625 C 6.320312 13.804688 6.6875 13.917969 7.066406 13.992188 C 7.441406 14.066406 7.824219 14.105469 8.207031 14.105469 Z M 8.21875 14.105469 "/>
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 29.835938 24.066406 L 29.835938 25.429688 C 30.125 25.429688 30.414062 25.460938 30.699219 25.515625 C 30.984375 25.574219 31.261719 25.660156 31.53125 25.773438 C 31.800781 25.886719 32.054688 26.023438 32.296875 26.183594 C 32.539062 26.347656 32.761719 26.53125 32.96875 26.738281 C 33.171875 26.945312 33.355469 27.171875 33.515625 27.414062 C 33.679688 27.65625 33.8125 27.910156 33.925781 28.179688 C 34.035156 28.449219 34.117188 28.726562 34.175781 29.015625 C 34.230469 29.300781 34.257812 29.589844 34.257812 29.878906 C 34.253906 30.171875 34.226562 30.460938 34.167969 30.746094 C 34.109375 31.03125 34.027344 31.308594 33.914062 31.578125 C 33.800781 31.84375 33.664062 32.101562 33.5 32.34375 C 33.339844 32.582031 33.152344 32.808594 32.949219 33.011719 C 32.742188 33.21875 32.515625 33.402344 32.273438 33.5625 C 32.03125 33.722656 31.773438 33.859375 31.503906 33.96875 C 31.238281 34.082031 30.957031 34.164062 30.671875 34.21875 C 30.386719 34.277344 30.097656 34.304688 29.808594 34.300781 C 29.515625 34.300781 29.226562 34.273438 28.941406 34.214844 C 28.65625 34.15625 28.378906 34.074219 28.109375 33.960938 C 27.84375 33.847656 27.585938 33.710938 27.34375 33.546875 C 27.101562 33.386719 26.878906 33.203125 26.675781 32.996094 C 26.46875 32.789062 26.285156 32.5625 26.125 32.320312 C 25.964844 32.078125 25.828125 31.824219 25.714844 31.554688 C 25.605469 31.285156 25.523438 31.007812 25.464844 30.722656 C 25.410156 30.433594 25.382812 30.144531 25.382812 29.855469 L 23.980469 29.855469 C 23.980469 30.238281 24.019531 30.621094 24.09375 30.996094 C 24.167969 31.375 24.28125 31.738281 24.429688 32.09375 C 24.574219 32.449219 24.757812 32.789062 24.96875 33.105469 C 25.183594 33.425781 25.425781 33.722656 25.699219 33.992188 C 25.96875 34.265625 26.265625 34.507812 26.585938 34.722656 C 26.90625 34.9375 27.242188 35.117188 27.597656 35.261719 C 27.953125 35.410156 28.316406 35.523438 28.695312 35.597656 C 29.070312 35.671875 29.453125 35.710938 29.835938 35.710938 C 30.214844 35.707031 30.589844 35.664062 30.957031 35.582031 C 31.328125 35.503906 31.6875 35.390625 32.035156 35.242188 C 32.382812 35.09375 32.710938 34.910156 33.023438 34.699219 C 33.335938 34.484375 33.625 34.242188 33.890625 33.972656 C 34.15625 33.703125 34.394531 33.410156 34.601562 33.09375 C 34.808594 32.78125 34.984375 32.445312 35.128906 32.097656 C 35.273438 31.746094 35.378906 31.386719 35.453125 31.015625 C 35.527344 30.644531 35.5625 30.269531 35.5625 29.890625 C 35.5625 29.511719 35.527344 29.136719 35.453125 28.765625 C 35.378906 28.394531 35.273438 28.035156 35.128906 27.6875 C 34.984375 27.335938 34.808594 27.003906 34.601562 26.6875 C 34.394531 26.371094 34.15625 26.078125 33.890625 25.808594 C 33.625 25.539062 33.335938 25.296875 33.023438 25.085938 C 32.710938 24.871094 32.382812 24.691406 32.035156 24.542969 C 31.6875 24.390625 31.328125 24.277344 30.957031 24.199219 C 30.589844 24.121094 30.214844 24.078125 29.835938 24.070312 Z M 29.835938 24.066406 "/>
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 8.214844 34.304688 C 7.921875 34.300781 7.632812 34.273438 7.347656 34.21875 C 7.0625 34.160156 6.785156 34.078125 6.515625 33.964844 C 6.246094 33.851562 5.992188 33.71875 5.75 33.554688 C 5.507812 33.394531 5.28125 33.210938 5.078125 33.003906 C 4.871094 32.796875 4.6875 32.574219 4.523438 32.332031 C 4.363281 32.089844 4.226562 31.832031 4.113281 31.5625 C 4.003906 31.292969 3.917969 31.015625 3.863281 30.730469 C 3.804688 30.445312 3.777344 30.15625 3.777344 29.867188 C 3.777344 29.574219 3.804688 29.285156 3.863281 29 C 3.917969 28.714844 4.003906 28.4375 4.113281 28.167969 C 4.226562 27.898438 4.363281 27.644531 4.523438 27.402344 C 4.6875 27.160156 4.871094 26.933594 5.078125 26.730469 C 5.28125 26.523438 5.507812 26.339844 5.75 26.175781 C 5.992188 26.015625 6.246094 25.878906 6.515625 25.765625 C 6.785156 25.65625 7.0625 25.570312 7.347656 25.515625 C 7.632812 25.457031 7.921875 25.429688 8.214844 25.429688 L 8.214844 24.066406 C 7.832031 24.070312 7.453125 24.109375 7.078125 24.1875 C 6.703125 24.261719 6.339844 24.375 5.988281 24.523438 C 5.636719 24.671875 5.300781 24.851562 4.984375 25.066406 C 4.667969 25.28125 4.375 25.523438 4.109375 25.796875 C 3.839844 26.070312 3.601562 26.363281 3.390625 26.683594 C 3.179688 27.003906 3.003906 27.339844 2.859375 27.691406 C 2.714844 28.046875 2.605469 28.410156 2.535156 28.785156 C 2.460938 29.160156 2.425781 29.539062 2.429688 29.921875 C 2.429688 30.304688 2.46875 30.683594 2.546875 31.058594 C 2.625 31.433594 2.738281 31.796875 2.886719 32.148438 C 3.035156 32.5 3.214844 32.835938 3.429688 33.152344 C 3.644531 33.46875 3.886719 33.757812 4.160156 34.027344 C 4.429688 34.296875 4.726562 34.535156 5.042969 34.746094 C 5.363281 34.957031 5.699219 35.132812 6.054688 35.277344 C 6.410156 35.421875 6.773438 35.53125 7.148438 35.601562 C 7.523438 35.675781 7.902344 35.710938 8.285156 35.707031 C 8.667969 35.707031 9.046875 35.667969 9.417969 35.589844 C 9.792969 35.511719 10.15625 35.398438 10.507812 35.25 C 10.863281 35.101562 11.195312 34.921875 11.511719 34.707031 C 11.828125 34.492188 12.121094 34.25 12.390625 33.976562 C 12.660156 33.707031 12.898438 33.410156 13.109375 33.089844 C 13.320312 32.773438 13.496094 32.4375 13.640625 32.082031 C 13.785156 31.726562 13.890625 31.363281 13.964844 30.988281 C 14.035156 30.613281 14.070312 30.234375 14.070312 29.851562 L 12.664062 29.851562 C 12.664062 30.144531 12.632812 30.433594 12.578125 30.71875 C 12.519531 31.007812 12.4375 31.285156 12.324219 31.554688 C 12.214844 31.824219 12.078125 32.082031 11.914062 32.324219 C 11.753906 32.570312 11.566406 32.792969 11.359375 33 C 11.15625 33.207031 10.929688 33.390625 10.6875 33.554688 C 10.445312 33.714844 10.1875 33.851562 9.917969 33.964844 C 9.648438 34.078125 9.367188 34.160156 9.082031 34.21875 C 8.796875 34.273438 8.503906 34.304688 8.214844 34.304688 Z M 8.214844 34.304688 "/>
              <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 29.835938 3.851562 C 30.128906 3.851562 30.417969 3.878906 30.703125 3.9375 C 30.988281 3.992188 31.269531 4.078125 31.539062 4.191406 C 31.808594 4.300781 32.066406 4.4375 32.308594 4.601562 C 32.550781 4.761719 32.777344 4.949219 32.980469 5.152344 C 33.1875 5.359375 33.375 5.585938 33.535156 5.828125 C 33.699219 6.070312 33.835938 6.328125 33.945312 6.597656 C 34.058594 6.867188 34.144531 7.144531 34.199219 7.433594 C 34.257812 7.71875 34.285156 8.007812 34.285156 8.300781 C 34.285156 8.59375 34.257812 8.882812 34.199219 9.167969 C 34.144531 9.457031 34.058594 9.734375 33.945312 10.003906 C 33.835938 10.273438 33.699219 10.53125 33.535156 10.773438 C 33.375 11.015625 33.1875 11.242188 32.980469 11.449219 C 32.777344 11.65625 32.550781 11.839844 32.308594 12.003906 C 32.066406 12.164062 31.808594 12.300781 31.539062 12.414062 C 31.269531 12.523438 30.988281 12.609375 30.703125 12.667969 C 30.417969 12.722656 30.128906 12.753906 29.835938 12.753906 L 29.835938 14.105469 C 30.214844 14.105469 30.59375 14.070312 30.96875 13.996094 C 31.34375 13.925781 31.707031 13.816406 32.058594 13.667969 C 32.410156 13.523438 32.746094 13.347656 33.0625 13.132812 C 33.378906 12.921875 33.671875 12.679688 33.941406 12.410156 C 34.210938 12.140625 34.453125 11.847656 34.664062 11.53125 C 34.875 11.210938 35.050781 10.875 35.195312 10.523438 C 35.339844 10.171875 35.449219 9.804688 35.519531 9.433594 C 35.59375 9.058594 35.628906 8.679688 35.625 8.296875 C 35.628906 7.914062 35.59375 7.535156 35.523438 7.160156 C 35.453125 6.785156 35.34375 6.421875 35.199219 6.066406 C 35.054688 5.710938 34.878906 5.375 34.667969 5.054688 C 34.457031 4.734375 34.21875 4.4375 33.949219 4.167969 C 33.679688 3.894531 33.386719 3.652344 33.070312 3.4375 C 32.753906 3.222656 32.421875 3.042969 32.066406 2.894531 C 31.714844 2.746094 31.351562 2.632812 30.976562 2.558594 C 30.601562 2.480469 30.222656 2.441406 29.839844 2.441406 C 29.457031 2.441406 29.074219 2.480469 28.695312 2.554688 C 28.320312 2.628906 27.953125 2.742188 27.597656 2.886719 C 27.242188 3.035156 26.90625 3.214844 26.585938 3.429688 C 26.265625 3.644531 25.96875 3.886719 25.699219 4.15625 C 25.425781 4.429688 25.183594 4.726562 24.96875 5.042969 C 24.757812 5.363281 24.578125 5.703125 24.429688 6.058594 C 24.28125 6.414062 24.171875 6.777344 24.097656 7.15625 C 24.019531 7.53125 23.984375 7.914062 23.984375 8.296875 L 25.386719 8.296875 C 25.386719 8.007812 25.417969 7.71875 25.476562 7.433594 C 25.53125 7.144531 25.617188 6.867188 25.730469 6.597656 C 25.84375 6.328125 25.980469 6.074219 26.140625 5.832031 C 26.304688 5.589844 26.488281 5.367188 26.695312 5.160156 C 26.902344 4.953125 27.125 4.769531 27.367188 4.605469 C 27.609375 4.445312 27.867188 4.308594 28.136719 4.195312 C 28.40625 4.082031 28.683594 3.996094 28.96875 3.9375 C 29.253906 3.882812 29.542969 3.851562 29.835938 3.851562 Z M 29.835938 3.851562 "/>
            </g>
          </svg>
          Drone
        </button>
      </div>
    </div>
    
    <div class='navbar-center'>
      <div id="runStopButton">
        <button id="runButton" v-if="codeRunningState == 'not running'" @click="$emit('run-code')">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M8 5v14l11-7z"/></svg>
          <span>Run</span>
        </button>
        <button id="stopButton" v-else @click="$emit('emergency-land')">
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M8 6h8c1.1 0 2 .9 2 2v8c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2z"/></svg>
          <span>Stop</span>
        </button>
      </div>
      
      <div id="cutoffButton">
        <div class="tooltip-hover">
          <button id='emergencyButton' @click="$emit('emergency-cutoff')">Emergency Land</button>
            <div class="tooltip cutoff-tooltip">For emergency purposes only, will cut off power to the drone</div>

        </div>
      </div>
      

    </div>
    <div class="navbar-right">
      <div class="tooltip-hover">
        <VueToggles 
          @click="toggleTextEditor" 
          :value="textEditorOpen" 
          width='90'
          checkedText="Code"
          uncheckedText="Blocks"
          checkedBg="#6f0"
          uncheckedBg="#ccc"
          checkedColor="black"
          uncheckedColor="black"
          dotColor="black"
        />
        <div class="tooltip toggle-tooltip">
          Toggle between block-coding and JavaScript
        </div>
      </div>
      
      <div class='connect-drone' >
        <button @click="$emit('change-sidebar-view', 'drone', true)">+ Connect Drone</button>
      </div>
      <div class='tooltip-hover'>
        <div class='connection-indicator' 
          :class="{
            indicatorConnected: droneConnectedState == 'connected', 
            indicatorDisconnected: droneConnectedState == 'disconnected',
            indicatorConnecting: droneConnectedState == 'connecting'
          }">
        </div>
        <div class='connection-tooltip tooltip'>Drone is {{droneConnectedState}}</div>      
      </div>
      <svg id="three-dot" @click="toggleMenu" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="37.5pt" height="37.499999pt" viewBox="0 0 37.5 37.499999" version="1.2">
        <g id="surface1">
          <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 18.539062 10.3125 C 20.753906 10.3125 22.550781 8.425781 22.550781 6.09375 C 22.550781 3.761719 20.753906 1.875 18.539062 1.875 C 16.320312 1.875 14.527344 3.761719 14.527344 6.09375 C 14.527344 8.425781 16.320312 10.3125 18.539062 10.3125 Z M 18.539062 14.53125 C 16.320312 14.53125 14.527344 16.417969 14.527344 18.75 C 14.527344 21.082031 16.320312 22.96875 18.539062 22.96875 C 20.753906 22.96875 22.550781 21.082031 22.550781 18.75 C 22.550781 16.417969 20.753906 14.53125 18.539062 14.53125 Z M 18.539062 27.1875 C 16.320312 27.1875 14.527344 29.074219 14.527344 31.40625 C 14.527344 33.738281 16.320312 35.625 18.539062 35.625 C 20.753906 35.625 22.550781 33.738281 22.550781 31.40625 C 22.550781 29.074219 20.753906 27.1875 18.539062 27.1875 Z M 18.539062 27.1875 "/>
        </g>
      </svg>
      <div class="dropdown-menu" v-if="menuOpen && codeRunningState == 'not running'">
        <div class="menu-item" @click="cleanUpBlocks">
          Clean up blocks
        </div>
        <div class="menu-item" @click="newProject">
          New Project
        </div>
        <div class="menu-item" @click="openProject">
          Open Project...
        </div>
        <div class="menu-item" @click="saveProject">
          Save Project...
        </div>
        <div class="menu-item" @click="saveAs">
          Save Project As...
        </div>
        <div class="menu-item" @click="downloadWorkspace">
          Download Project
        </div>
        <input id='file-upload' type='file' accept=".xml" @change="fileUploaded">
        <label for="file-upload" class="menu-item">
          Import Project
        </label>
        <!-- <div class='menu-item' @click="safariUpload">
          Import Project
        </div> -->
      </div>
      
    </div>
    
  </header>
</template>

<script>
import Blockly from 'blockly';
// import Swal from "sweetalert2";
import VueToggles from 'vue-toggles';

export default {
  name: 'ControlBar',
  components: {
    VueToggles
  },
  props: {
    codeRunningState: String,
    sidebarViewState: String,
    droneConnectedState: String,
    workspace: Object
  },
  data () {
      return {
        menuOpen: false,
        textEditorOpen: false
      }
  },
  methods: {
    closeMenu () {
      this.menuOpen = false;
    },
    toggleMenu () {
      this.menuOpen = !this.menuOpen;
    },
    newProject () {
      this.$emit('new-project');
      this.closeMenu();
    },
    cleanUpBlocks () {
      this.workspace.cleanUp();
      this.closeMenu();
    },
    saveProject () {
      this.$emit('save-project');
      this.closeMenu();
    },
    saveAs () {
      this.$emit('save-as');
      this.closeMenu();
    },
    async downloadWorkspace () {
      let xml = Blockly.Xml.workspaceToDom(this.workspace, true);
      let xml_text = Blockly.Xml.domToText(xml);
      this.$emit('download-project', xml_text);
      this.closeMenu();
    },
    async fileUploaded (event) {
      let file = event.target.files[0];
      let fileText = await file.text();
      
      let xml_text, code;

      try {
        let data = JSON.parse(fileText);
        xml_text = JSON.parse(data.data);
        code = data.code;
        if (code == '') code = null;
      } catch (e) {
        //backwards compatibility
        let re = /<ftwcode>(.*)<\/ftwcode>/s;
        let match = re.exec(fileText);
        if (match) {
          code = match[1];
          xml_text = fileText.substring(0, match.index);
        } else {
          code = null;
          xml_text = fileText;
        }
      }
      

      this.$emit('import-project', xml_text, code);

      //clear file input element so that if same file uploaded again it still registers 'change' event
      event.target.value = '';
      this.closeMenu();

    },
    openProject () {
      this.$emit('open-project');
      this.closeMenu();
    },
    toggleTextEditor () {
      this.textEditorOpen = ! this.textEditorOpen;
      this.$emit('toggle-text-mode', this.textEditorOpen);
    }
    // async safariUpload () {
    //   let {value: file} = await Swal.fire({
    //     title: 'File upload',
    //     text: 'Note: If the Choose File button does not work try dragging and dropping the file',
    //     // html: '<input id="file-upload" type="file" accept=".xml" @change="fileUploaded">'
    //     input: 'file',
    //     inputAttributes: {
    //       'accept' : '.xml'
    //     }
    //   });
    //   if(file) {
    //     let fileText = await file.text();
    //     this.$emit('import-project', fileText);
    //     this.closeMenu();
    //   }
    // }
  }
}
</script>

<style scoped>
header {
  display: grid;
  grid-template: 1fr / 1fr 1fr 1fr;
  max-height: 65px;
  color: white;
}
#runStopButton {
  display: flex;
  align-items: center;
  justify-content: center;
}
.navbar-center button {
  position: relative;
  height: 40px;
  width: 120px;
  padding: 0px;
  white-space: nowrap;
  border: none;
  font-weight: 400;
  text-transform: uppercase;
  display: inline;
  
}
#runButton {
  background-color: #66FF00;
}
#stopButton {
  background-color: red;
}
#emergencyButton {
  background-color: red;
}
#runStopButton svg {
  height: 16px;
  width: 16px;
  position: absolute;
  left: 6px;
  top: 12px;
}
#cutoffButton {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 12px;
}
.navbar-left {
  display: flex;
  align-content: center;
}
.sidebar-nav {
  display: flex;
  min-width: 210px;
  width: 250px;
  justify-content: space-around;
}
.sidebar-nav button {
  height: 65px;
  width: 65px;
  border: none;
  background: none;
  color: #f2f2f2;
  text-transform: uppercase;
  line-height: 1;
  
}
.sidebar-nav button:hover {
  background-color:#CCC;
  color: #242323;
}
.sidebar-nav button:hover svg {
  fill: #242323;
}
.sidebar-nav button svg {
  fill:  #f2f2f2;
  height: 32px;
  width: auto;
}
.sidebar-nav .highlightedButton svg {
  fill: #242323;
}
button:focus{
    outline: none;
}
.sidebar-nav .highlightedButton {
  background-color:  #f2f2f2;
  color: #242323;
}
#console-icon {
  height: 28px;
  margin-bottom: 4px;
}
.navbar-center {
  display: inline-flex;
  justify-content: center;
  max-height: 65px;
}
.navbar-right {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.connect-drone {
  height: 100%;
}
.connect-drone button{
  height: 100%;
  width: auto;
  background: none;
  color: white;
  padding: 0px 12px;
  text-transform: uppercase;
  border: none;
  font-size: 18px;
  font-weight: 400;
}
.connect-drone button:hover {
  color: #6f0;
}
.connect-drone button {
  white-space: nowrap;
}
.connection-indicator {
  background-color: red;
  margin: 0px 6px;
  border: 3px solid #fff;
  border-radius: 50%;
  display: block;
  height: 24px;
  padding: 0;
  position: relative;
  width: 24px;
}
.tooltip-hover {
  position: relative;
}
.tooltip {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  
  pointer-events: none;
  position: absolute;
  z-index: 100;
}
.connection-tooltip {
  right: 0;
  bottom: -110%;
  white-space: nowrap;
}
.toggle-tooltip {
  width: 160px;
  left: -50px;
}
.tooltip-hover:hover .tooltip {
  visibility: visible;
}
.indicatorConnected {
  background-color: #66FF00;
}
.indicatorConnecting {
  background-color: yellow;
}
.cutoff-tooltip {
  width: 160px;
  left: -20px;
}
#three-dot{
  fill: white;
  height: 24px;
  width: auto;
  padding-right: 6px;
}
#three-dot:hover {
  fill:#6f0;
  cursor: pointer;
}
.dropdown-menu {
  position: absolute;
  background-color: #242323;
  top: 100%;
  right: 0;
  z-index: 99;
}
.menu-item {
  display: block;
  padding: 12px;
  text-decoration: none;
  color: white;
}
.menu-item:hover {
  color: #6f0;
  cursor: pointer;
}
#file-upload {
  position: absolute;
  z-index: -100;
  opacity: 0;
}
.vue-toggles:focus {
  outline: none;
}
</style>